import React from 'react'
import { JsonLd } from 'react-schemaorg'
import { Corporation } from 'schema-dts'
import { usePageContext } from 'src/contexts/page.context'
import { useSecurityContext } from 'src/contexts/security.context'
import { makeGoogleTicker, makeSecurityLink } from 'src/shared/utils'

export const CorporationSchema: React.FC = () => {
  const { siteUrl } = usePageContext()
  const { security } = useSecurityContext()
  const { stockRank } = security.ranks

  return (
    <>
      {stockRank && (
        <JsonLd<Corporation>
          item={{
            '@context': 'https://schema.org',
            '@type': 'Corporation',
            name: security.name,
            tickerSymbol: makeGoogleTicker(security),
            alternateName: security.ticker,
            url: `${siteUrl}${makeSecurityLink(security)}`,
            // @ts-ignore
            Review: [
              {
                '@type': 'Review',
                additionalType:
                  'http://www.productontology.org/id/Fundamental_analysis',
                author: {
                  '@type': 'Organization',
                  name: 'Stockopedia',
                },
                reviewRating: [
                  {
                    '@type': 'Rating',
                    ratingValue: security.ranks.stockRank,
                    bestRating: 99,
                    worstRating: 0,
                  },
                ],
              },
            ],
          }}
        />
      )}
    </>
  )
}
